module.exports = __webpack_public_path__ + "static/media/mujtabaprofile.97b09a70.jpg";